<!--
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2025 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see <http://www.gnu.org/licenses/>.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<div class="file-upload"
     (drop)="onDrop($event)"
     (dragover)="onDragOver($event)">
    <input #uploadInput
           type="file" [id]="elementId"
           (change)="onFileSelected($event)" [disabled]="!enabled()"
           class="upload-input d-none"
           [accept]="acceptedTypes"
           [multiple]="allowMultiple"
    />
    <label [for]="elementId" class="upload-label-container">
        <div>
                <span class="">
                    <scrm-image *ngIf="showUploadIcon" [image]="'upload'"></scrm-image>
                    <scrm-label class="pl-1 upload-label" [labelKey]="uploadLabel"></scrm-label>
                </span>
        </div>
        <div>
                <span class="text-muted small">
                    <scrm-label [labelKey]="uploadDescription"></scrm-label>
                </span>
        </div>
    </label>
</div>
